import { z } from "zod";
import { createInvoiceRequestSchema } from "../createInvoice/createInvoice.schema";

const additionalRecipientEmailSchema = z
  .string()
  .min(1)
  .regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email address");

const normalizeAdditionalRecipientEmails = (val: unknown): string[] => {
  if (Array.isArray(val)) {
    return val.map((e) => String(e).trim().toLowerCase()).filter(Boolean);
  }
  if (typeof val === "string") {
    const raw = val.trim();
    if (!raw) return [];
    return raw
      .split(",")
      .map((e) => e.trim().toLowerCase())
      .filter(Boolean);
  }
  return [];
};

const updateInvoiceBaseSchema = z.object({
  invoiceID: z.string().min(1, "Invoice ID is required"),

  additionalRecipientEmails: z
    .preprocess(
      normalizeAdditionalRecipientEmails,
      z.array(additionalRecipientEmailSchema)
    )
    .default([]),

  marked_paid_at: z.string().optional(),
  marked_paid_payment_method: z.string().optional(),
});

export const updateInvoiceRequestSchema = createInvoiceRequestSchema
  .partial()
  .merge(updateInvoiceBaseSchema)
  .passthrough();

/** Input type for PATCH: all fields except invoiceID are optional (partial update). */
export type TUpdateInvoiceRequest = z.input<typeof updateInvoiceRequestSchema>;
